import { render, staticRenderFns } from "./Course-item.vue?vue&type=template&id=54fff9f5&scoped=true&"
import script from "./Course-item.vue?vue&type=script&lang=js&"
export * from "./Course-item.vue?vue&type=script&lang=js&"
import style0 from "./Course-item.vue?vue&type=style&index=0&id=54fff9f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fff9f5",
  null
  
)

export default component.exports